// extracted by mini-css-extract-plugin
export var closeButton = "_nd-2";
export var closeButtonIcon = "_nd-3";
export var lightboxContent = "_nd-1";
export var lightboxOverlay = "_nd-0";